import { ACTIONS } from "../../../Models/ENUM";
import ARRAY from "../../../UTIL/ARRAY";
import CONQUER from "../../CONQUER";
import GameInstance from "../GameInstance";
import MATH from "../../../UTIL/MATH";
import RANDOM from "../../../UTIL/RANDOM";
import LOG, { log } from "../../../UTIL/LOG";
import ShopItem from "../SHOP/ShopItem";
import DATE from "../../../UTIL/DATE";

class ScoreboardInstance
{
    private conquer             : CONQUER;
    private query               : any;
    private gameInstance        : GameInstance;

    private ladder              : any;
    private ladderLength        : number = 0;

    private scoreboardID        : string;
    private scoreboardEntryID   : string;

    public endDate              : number = 0;

    private rewards             : any = [ "Loot_Legendary", "Loot_Legendary","Loot_Legendary","Loot_Epic", "Loot_Rare", "Coin5K", "Coin4K", "Coin3K", "Coin2K", "Coin1K" ];

    public items                : any;
    private isCollected          : any;

    public shopItem             : any | ShopItem;

    constructor( gameInstance:GameInstance, vars:any )
    {
        this.gameInstance       = gameInstance;
        this.conquer            = gameInstance.conquer;

        this.scoreboardID       = vars.scoreboardID;
        this.scoreboardEntryID  = vars._id;
    }

    public async get() : Promise<any>
    {
        let scoreboard  = await this.conquer.do( ACTIONS.SCOREBOARD_GET, { scoreboardID:this.scoreboardID });

        this.endDate    = scoreboard.endDate;
        this.items      = [];

        let bots :any   = await this.conquer.Bots.get( 25 - scoreboard.items.length );
 
        for( let n=0; n< bots.length; n++ )
        {
            let item = bots[n];
 
            this.items.push(
            {
                fullName    : item.fullName,
                userPhoto   : item.userPhoto,
                avatarID    : item.avatarID,
                score       : RANDOM.value( n*500, n*10 ),
                avatar      : item
            });
        }

        for( let n in scoreboard.items )
        {
            let item        = scoreboard.items[n];
            item.avatar     = this.conquer.Avatars.pushInstance( item );
            item.fullName   = item.avatar.fullName;

            this.items.push( item );
        }
 
        this.items = ARRAY.sort( this.items, "score" );
        this.items.reverse();
  
        for( let n=0; n< this.items.length; n++ )
        {
            let item        = this.items[n];

            item.rank       = n+1;

            let isME        = item.avatarID === this.conquer.Avatars.ME.avatarID;
            
            if( this.gameInstance.Shop.items )
            {
                let shopItem    = this.gameInstance.Shop.items[ this.rewards[n] ];
                if( shopItem ) 
                {
                    item.shopItem = shopItem;
                    if( isME ) this.shopItem = shopItem;
                }
            }
   
        }
 
        this.gameInstance.Signal.set( "SCOREBOARD:onRefresh" ); 
 
        return Promise.resolve( this );
    }

    public async set( score:number ) : Promise<any>
    {
        if( !score || this.endDate < DATE.now() ) return;

        this.gameInstance.Data.setMax( "Score", score );

        await this.conquer.do( ACTIONS.SCOREBOARD_ENTRIES_SET, { scoreboardEntryID:this.scoreboardEntryID, score:score, gameID:this.gameInstance.gameID } );
        return this.get();
    }

    public collect() : any
    {
        if( this.isCollected || this.endDate > DATE.now() ) return;

        this.isCollected = true;
 
        let result = this.shopItem ? this.shopItem.set( true ) : false;
 
        this.gameInstance.Scoreboard.remove( this );

        this.gameInstance.Analytics.onCollectScoreboard( this.shopItem ? this.shopItem.key : null );

        this.conquer.do( ACTIONS.SCOREBOARD_ENTRIES_SET, { scoreboardEntryID:this.scoreboardEntryID, isCollected:true } );

        return result ;
    }
};

export default ScoreboardInstance;